import React, { useState } from 'react';
import { Row, Col } from 'antd';
import PagesHeader from '../../components/PageHeader';
import InstallationGuideData from "../../datatables/InstallationGuideDataTable";
import ButtonBar from '../../components/ButtonNavigation';

const InstallationGuideline = () => {

  const [refreshKey, setRefreshKey] = useState(0); 

  return (
      <div className="inspectionWrapper">
        <div className="inspectionHeader">
          <PagesHeader title="Installation Guide" />
        </div>
           <div className="buttonSection">
        <div className="container-xxl">
          <Row>
            <Col xs={24} md={18} className="text-end">
              <ButtonBar />
            </Col>
          </Row>
        </div>
      </div>

        <div className="inspectionWrapInner">
          <div className="container-xxl">
            <Row gutter={16}>
              <Col md={24}>
                <InstallationGuideData key={refreshKey} />
              </Col>
            </Row>
          </div>
        </div>
      </div>
  );
};

export default InstallationGuideline;
